var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217,
    height: 161,
    viewBox: "0 0 217 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-28h217v217H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M191.144 80.826c-.48 43.73-36.053 79.03-79.865 79.03-44.11 0-79.87-35.784-79.87-79.928 0-3.654.246-7.252.72-10.777H7.185a7.185 7.185 0 1 1 0-14.369h56.527a7.185 7.185 0 0 0 2.505-13.92 7.17 7.17 0 0 1-2.506.45H30.517a7.185 7.185 0 0 1 0-14.37H51.48C66.113 10.416 87.48 0 111.28 0c34.326 0 63.595 21.671 74.89 52.088h22.922a7.185 7.185 0 1 1 0 14.37h-34.989a7.185 7.185 0 0 0 0 14.368h17.041z",
    transform: "translate(.723 .933)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M100.722 126.07a8.582 8.582 0 0 0-.75 3.517c0 4.773 3.882 8.642 8.671 8.642 4.79 0 8.672-3.87 8.672-8.642 0-1.253-.27-2.442-.751-3.517h-15.842"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M133.308 97.774V82.432c0-13.594-11.162-24.717-24.803-24.717-13.642 0-24.803 11.123-24.803 24.717v15.342c0 3.06.855 14.49-5.56 14.49-3.763 0-6.842 3.067-6.842 6.818 0 3.75 3.079 6.818 6.842 6.818h60.725c3.763 0 6.842-3.068 6.842-6.818 0-3.75-3.079-6.819-6.842-6.819-6.414 0-5.56-11.43-5.56-14.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M108.641 57.587c1.59 0 3.145.153 4.653.442a6.067 6.067 0 0 0 1.477-3.97c0-3.374-2.744-6.109-6.13-6.109-3.385 0-6.13 2.735-6.13 6.108 0 1.517.559 2.902 1.478 3.97a24.76 24.76 0 0 1 4.652-.44"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#64808C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.267 95.328c-10.463 12.223-10.463 24.446 0 36.669M69.485 102.2c-6.774 7.914-6.774 15.828 0 23.742"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#64808C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.733 95.328c10.463 12.223 10.463 24.446 0 36.669"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.723,
    d: "M147.515 102.2c6.774 7.914 6.774 15.828 0 23.742"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationEmpty);
export default __webpack_public_path__ + "static/media/notification-empty.94527ca9358531b42ede308b430e7d20.svg";
export { ForwardRef as ReactComponent };